(function ($) {
  jQuery(document).ready(function () {
    jQuery(".mini-cards-section").each((i, item) => {
      $(jQuery(item).find(".mini-cards-container")).slick({
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        dots: false,
        prevArrow: jQuery(item).find(".mini-card-prev"),
        nextArrow: jQuery(item).find(".mini-card-next"),
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 2,
            },
          },
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
            },
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      });
    });
  });
})(jQuery);
